import React from "react";
import DaftarPengguna from "../../components/Pengguna/Home";


export default function Home() {
  return (
    <DaftarPengguna />
  );
}
